import { authHeader, authHeaderUpload, handleResponse } from '@/api/handler/main';

export const landingPageService = {
    getListLandingPage,
    getDetailLandingPage,
    registerLandingPage,
    updateLandingPage,
    deleteLandingPage,
    getDetailCampaignForLandingPage,
    copyLandingPage,
    syncLandingPagePublish,
    uploadZipLandingPage
};

function getListLandingPage(query) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };
    return fetch(process.env.VUE_APP_APIURL + `/landing-pages?${query}`, requestOptions).then(handleResponse);
}

function getDetailLandingPage(id) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };
    return fetch(process.env.VUE_APP_APIURL + `/landing-pages/${id}`, requestOptions).then(handleResponse);
}

function registerLandingPage(payload) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(payload)
    };
    return fetch(process.env.VUE_APP_APIURL + `/landing-pages`, requestOptions).then(handleResponse);
}

function copyLandingPage(payload) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(payload)
    };
    return fetch(process.env.VUE_APP_APIURL + `/landing-pages/copy`, requestOptions).then(handleResponse);
}

function syncLandingPagePublish(payload) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: ''
    };
    return fetch(process.env.VUE_APP_APIURL + `/landing-pages/${payload?.id}/sync-publish-data`, requestOptions).then(handleResponse);
}

function updateLandingPage(payload) {
    const requestOptions = {
        method: 'PUT',
        headers: authHeader(),
        body: JSON.stringify(payload)
    };
    return fetch(process.env.VUE_APP_APIURL + `/landing-pages/${payload.id}`, requestOptions).then(handleResponse);
}

function deleteLandingPage(payload) {
    const requestOptions = {
        method: 'DELETE',
        headers: authHeader(),
        body: JSON.stringify(payload)
    };
    return fetch(process.env.VUE_APP_APIURL + `/landing-pages/${payload.id}`, requestOptions).then(handleResponse);
}

function getDetailCampaignForLandingPage(id) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
        body: JSON.stringify()
    };
    return fetch(process.env.VUE_APP_APIURL + `/campaigns/${id}/for-landing-page`, requestOptions).then(handleResponse);
}

function uploadZipLandingPage(payload) {
    const id = payload?.id;
    const formData = payload?.formData || payload;
    const requestOptions = {
        method: 'POST',
        headers: authHeaderUpload(),
        body: formData
    };
    return fetch(process.env.VUE_APP_APIURL + `/landing-pages/${id}/upload-zip`, requestOptions).then((response) => {
        return handleResponse(response).then((data) => {
            if (!response.ok || (data && typeof data === 'object' && data.code && data.code !== 200 && data.code !== 201)) {
                const code = data?.code || response.status || 500;
                let message = data?.message || data?.error;
                if (!message && data?.errors) {
                    const firstVal = Object.values(data.errors)[0];
                    message = Array.isArray(firstVal) ? firstVal[0] : String(firstVal);
                }
                if (!message) {
                    message = response.statusText ? `HTTP ${response.status}: ${response.statusText}` : 'ZIPファイルのアップロードに失敗しました。';
                }
                return Promise.reject({
                    code,
                    message,
                    ...data
                });
            }
            return data;
        });
    });
}
